module.exports = __webpack_public_path__ + "static/img/background.2f3c942d.svg";